/* Vikas Tool Mart — product card behaviour
   Upload as: assets/vtm-product-card.js

   ONE delegated listener on `document`, registered once per page load.

   This is deliberately not per-button binding and not a custom element.
   Shopify's filter/sort/pagination replaces the innerHTML of #product-grid on
   every interaction, which destroys any listener attached to a card. A
   document-level listener is attached above the swapped subtree, so it keeps
   working across every filter click forever, with no re-init hook needed and
   no wrapper element around the button.

   Guarded so it stays safe if two sections on the same page both load it. */

(function () {
  if (window.__vtmProductCardInit) return;
  window.__vtmProductCardInit = true;

  document.addEventListener('click', function (event) {
    var card = event.target.closest('.vtm-pc__card');
    if (!card) return;

    /* let Glozin's wishlist component run, but don't follow the card link */
    if (event.target.closest('button-wishlist')) {
      event.preventDefault();
      return;
    }

    var btn = event.target.closest('.vtm-pc__cart');
    if (!btn || btn.disabled) return;

    /* the button sits inside the card's <a>; preventDefault here still stops
       navigation because the default action resolves after the event bubbles */
    event.preventDefault();
    event.stopPropagation();
    addToCart(btn);
  });

  var DRAWER = 'cart-drawer, #cart-drawer, .cart-drawer, cart-notification, #CartDrawer';

  /* Fetch the drawer's own section and swap the live element for the fresh one.
     Returns the new element (or the old one if anything went wrong) so the
     caller can open it. Never throws — a stale drawer beats a broken add. */
  async function refreshDrawer() {
    var live = document.querySelector(DRAWER);
    if (!live) return null;

    try {
      /* Ask for just this section when it is a real section, so we are not
         downloading and parsing a whole page for one drawer. */
      var wrapper = live.closest('[id^="shopify-section-"]');
      var url = wrapper
        ? location.pathname + '?section_id=' + encodeURIComponent(wrapper.id.replace('shopify-section-', ''))
        : location.pathname;

      var res = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!res.ok) return live;

      var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      var fresh = doc.querySelector(DRAWER);
      if (!fresh) return live;

      live.replaceWith(fresh);
      return document.querySelector(DRAWER);
    } catch (err) {
      console.warn('[vtm-card] drawer refresh failed, opening stale drawer', err);
      return live;
    }
  }

  async function addToCart(btn) {
    var id = btn.dataset.variantId;
    if (!id || btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');

      var cart = await (await fetch('/cart.js')).json();

      document
        .querySelectorAll('.cart-count, [data-cart-count], .cart-count-bubble span, .header__cart-count')
        .forEach(function (el) { el.textContent = cart.item_count; });

      /* Re-render the drawer from the server before opening it.

         We add via /cart/add.js, which the theme's own cart code knows nothing
         about, so its drawer keeps whatever markup it last rendered. Emptying
         the cart and adding again left it showing the stale "cart is empty"
         state while the header count said 1 — correct data, stale DOM.

         Replacing the drawer ELEMENT rather than its section wrapper keeps us
         clear of the header's own scripts, and a fresh custom element is
         upgraded on insertion, so the theme re-initialises it for us. */
      var drawer = await refreshDrawer();

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));

      if (drawer && typeof drawer.open === 'function') drawer.open();

      btn.classList.add('is-done');
      setTimeout(function () { btn.classList.remove('is-done'); }, 1200);
    } catch (err) {
      console.error('[vtm-card]', err);
    } finally {
      btn.classList.remove('is-loading');
    }
  }
})();
